import * as t from 'io-ts';

import {makeApiSerializableType} from './apiTypes';

/*
 * Runtime type.
 */

export enum DepartmentsEnum {
  ACCOUNT_MANAGEMENT = 'account-management',
  BROKER = 'broker',
  CEO_OWNER = 'ceo-owner',
  CLIENT_SERVICES_SUCCESS = 'client-services-success',
  CUSTOMER_SUPPORT = 'customer-support',
  ENGINEERING_PRODUCT = 'engineering-product',
  FINANCE_LEGAL = 'finance-legal',
  MARKETING_DESIGN = 'marketing-design',
  OPERATIONS = 'operations',
  PROJECT_MANAGEMENT = 'project-management',
  SALES_BUSINESS_DEVELOPMENT = 'sales-business-development',
  OTHER = 'other',
}

export enum IndustriesEnum {
  ECOMMERCE = 'ecommerce',
  EVENTS = 'events-experiences',
  FINANCIAL_SERVICES = 'financial-services',
  LOGISTICS = 'logistics',
  MARKETING_ADVERTISING = 'marketing-advertising',
  MANUFACTURING = 'manufacturing',
  PROFESSIONAL_SERVICES = 'professional-services',
  SAAS_TECHNOLOGY = 'software',
  TRAVEL_HOSPITALITY = 'travel-hospitality',
  HEALTH_FITNESS = 'health-fitness',
  OTHER = 'other',
}

export enum UseCasesEnum {
  GROUP_EMAIL = 'group-email',
  EMAIL_OVERLOAD = 'email-overload',
  IMPROVE_COORDINATION = 'improve-coordination',
  CENTRALIZE_COMMUNICATION = 'centralize-communication',
  MEASURE_PERFORMANCE = 'measure-performance',
}

const RApolloEnrichmentData = t.dictionary(t.string, t.any);

export const RUserMetadata = t.readonly(
  t.type({
    department: t.union([t.undefined, t.string]),
    industry: t.union([t.undefined, t.string]),
    useCases: t.readonlyArray(t.string),
    apolloEnrichmentData: RApolloEnrichmentData,
    teamSize: t.union([t.Integer, t.undefined]),
    mentorId: t.union([t.Integer, t.undefined]),
  }),
  'userMetadata',
);

/*
 * Type.
 */

export interface ApolloEnrichmentData extends Readonly<t.TypeOf<typeof RApolloEnrichmentData>> {}
export interface UserMetadataModel extends Readonly<t.TypeOf<typeof RUserMetadata>> {}

/*
 * IO methods.
 */

export function parseUserMetadata(src: any): UserMetadataModel {
  return {
    department: (src.metadata && src.metadata.department) || undefined,
    industry: (src.metadata && src.metadata.industry) || undefined,
    useCases: (src.metadata && src.metadata.challengesSolved) || [],
    apolloEnrichmentData: (src.metadata && src.metadata.apolloEnrichmentData) || {},
    teamSize: (src.metadata && src.metadata.teamSize) || undefined,
    mentorId: (src.metadata && src.metadata.mentorId) || undefined,
  };
}

export function serializeUserMetadata(userMetadata: UserMetadataModel) {
  const {department, industry, useCases, apolloEnrichmentData, teamSize} = userMetadata;

  return {
    metadata: {
      department,
      industry,
      challengesSolved: useCases,
      apolloEnrichmentData,
      teamSize,
    },
  };
}

/*
 * API type.
 */

export const ApiUserMetadata = makeApiSerializableType(
  'userMetadata',
  RUserMetadata,
  parseUserMetadata,
  serializeUserMetadata,
);
